import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Cloudflare R2 public CDN base URL */
export const R2 = "https://pub-56b94dd8a0c946a689522e687290e19d.r2.dev";

/** GCS CDN base URL for static assets (images migrated from public/) */
export const CDN_URL = import.meta.env.VITE_CDN_URL || "https://dev-cdn.wiserstudio.ai";

/** Prefix a public-folder path with the CDN URL when set, otherwise keep local. */
export function cdnUrl(path: string): string {
  return `${CDN_URL}/static${path.startsWith("/") ? path : `/${path}`}`;
}
